import { Language } from '../../enums';

export abstract class AbstractI18nService {
	public abstract get currentLanguage(): Language;
}
